import { compact } from '@lglp/utils';
import moment from 'moment';

import { DocumentType } from '../../types/document';
import { and, attr, period } from '../algolia/algolia-filters-builder';

const HUB_SLICE_NB_TAB_YEAR_ITEMS = 11;

export const searchFinancialPublication = ({
  hitsPerPage = 12,
  financialPublication = [],
  year,
}: SearchFinancialPublicationProps): SearchFinancialPublicationReturnProps => {
  const currentYear = new Date(Date.now()).getFullYear();
  const minYear = currentYear - HUB_SLICE_NB_TAB_YEAR_ITEMS;

  return compact<SearchFinancialPublicationReturnProps>({
    hitsPerPage,
    facets: ['filters.financialPublication'],
    facetFilters: {
      financialPublication,
    },
    filters: and(
      [
        attr('type', DocumentType.MEDIA_PRESS),
        attr('filters.mediaType', 'publication'),
        attr('onFinance', 'true'),

        year
          ? period(
              'relatedDate',
              moment(`${year}0101`, 'YYYYMMDD').valueOf(),
              moment(`${year}1231`, 'YYYYMMDD').valueOf()
            )
          : // Limiter tous les documents à la période année N à l'année N-x
            period(
              'relatedDate',
              moment(`${minYear}0101`, 'YYYYMMDD').valueOf(),
              moment(`${currentYear}1231`, 'YYYYMMDD').valueOf()
            ),
      ].filter(Boolean) as string[]
    ),
  });
};

type SearchFinancialPublicationProps = {
  hitsPerPage: number;
  financialPublication: string[];
  year: number;
};

type SearchFinancialPublicationReturnProps = {
  hitsPerPage: number;
  facets: string[];
  facetFilters: Record<string, any>;
  filters: string;
};
